import { render } from "./LabelsInput.vue?vue&type=template&id=6eab38ad&scoped=true&ts=true"
import script from "./LabelsInput.vue?vue&type=script&lang=ts"
export * from "./LabelsInput.vue?vue&type=script&lang=ts"

import "./LabelsInput.vue?vue&type=style&index=0&id=6eab38ad&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eab38ad"]])

export default __exports__